<template>
  <div class="clientes-page">
    <b-overlay :show="overlay" variant="white" spinner-variant="primary" blur="0" opacity=".75" rounded="md">

      <nav class="breadcrumb-nav">
        <router-link :to="{ name: 'dashboard-ptc' }" class="breadcrumb-link">
          <feather-icon icon="HomeIcon" size="14" />
          <span>Cadastros</span>
        </router-link>
        <feather-icon icon="ChevronRightIcon" size="14" class="breadcrumb-separator" />
        <span class="breadcrumb-current">Clientes</span>
      </nav>

      <ActionBar
        :active-filters-count="activeFiltersCount"
        :filter-chips="filterChipsData"
        :is-loading="overlay"
        :show-primary-action="false"
        @toggle-filters="openDrawer"
        @remove-chip="handleRemoveChip"
      >
        <template #left-content>
          <div class="search-input-wrapper">
            <feather-icon icon="SearchIcon" size="14" class="search-icon" />
            <input
              v-model="searchInputValue"
              type="text"
              class="search-input"
              placeholder="Buscar por razão social, CNPJ, código ERP, código KS..."
              @keyup.enter="handleSearch"
            />
          </div>
        </template>
        <template #actions>
          <button class="action-bar-btn primary-btn" :disabled="overlay" @click="handleSearch">
            <feather-icon icon="SearchIcon" size="14" />
            <span class="btn-text">Pesquisar</span>
          </button>
          <button class="action-bar-btn ghost-btn" @click="clearSearch">
            <feather-icon icon="XIcon" size="14" />
            <span class="btn-text">Limpar</span>
          </button>
          <button class="action-bar-btn primary-btn" @click="chamarRota">
            <feather-icon icon="PlusIcon" size="14" />
            <span class="btn-text">Cliente</span>
          </button>
        </template>
      </ActionBar>

      <div class="filter-drawer-overlay" v-if="drawerOpen" @click="closeDrawer"></div>
      <transition name="drawer-slide">
        <div class="filter-drawer" v-if="drawerOpen">
          <div class="drawer-header">
            <h3 class="drawer-title">Filtros</h3>
            <button class="drawer-close" @click="closeDrawer">
              <feather-icon icon="XIcon" size="18" />
            </button>
          </div>
          <div class="drawer-body">
            <div class="field-group">
              <label class="field-label">Situação</label>
              <select v-model="filterSituacao" class="field-input">
                <option value="">Todos</option>
                <option value="DIGITACAO">Digitação</option>
                <option value="FINALIZADO">Finalizado</option>
                <option value="CANCELADO">Cancelado</option>
              </select>
            </div>
            <div class="field-group">
              <label class="field-label">Sit. Integração</label>
              <select v-model="filterIntegracao" class="field-input">
                <option value="">Todos</option>
                <option value="INTEGRADO">Integrado</option>
                <option value="NAO_INTEGRADO">Não Integrado</option>
                <option value="ERRO">Erro</option>
              </select>
            </div>
            <div class="field-group">
              <label class="field-label">Tipo Pessoa</label>
              <select v-model="filterTipoPessoa" class="field-input">
                <option value="">Todos</option>
                <option value="J">Jurídica</option>
                <option value="F">Física</option>
              </select>
            </div>
            <div class="field-group">
              <label class="field-label">CNPJ/CPF</label>
              <input v-model="filterCnpj" type="text" class="field-input" placeholder="Digite o CNPJ ou CPF" />
            </div>
          </div>
          <div class="drawer-footer">
            <button class="action-bar-btn primary-btn w-full" @click="aplicarFiltros">
              <feather-icon icon="CheckIcon" size="14" />
              Aplicar
            </button>
            <button class="action-bar-btn ghost-btn w-full" @click="limparFiltrosDrawer">
              <feather-icon icon="XIcon" size="14" />
              Limpar
            </button>
          </div>
        </div>
      </transition>

      <div class="content-card">
        <div class="card-header">
          <div class="header-left">
            <span class="table-info">{{ dataMeta.from || 0 }} - {{ dataMeta.to || 0 }} de {{ dataMeta.of || 0 }} registros</span>
          </div>
          <div class="header-right">
            <div class="per-page-control">
              <label class="per-page-label">Exibir:</label>
              <select v-model="perPage" class="per-page-select">
                <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="table-container">
          <b-table
            ref="refClienteListTable"
            class="data-table-btable"
            :items="fetchCliente"
            responsive
            :fields="tableColumnsFormatted"
            primary-key="clienteid"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
            thead-class="table-header"
            tbody-class="table-body"
          >
            <template #cell(clienteid)="data">
              <span class="code-cell">{{ data.item.clienteid }}</span>
            </template>
            <template #cell(clienteiderp)="data">
              <span class="code-cell">{{ data.item.clienteiderp || '-' }}</span>
            </template>
            <template #cell(representanteid)="data">
              <span class="code-cell">{{ data.item.representanteid || '-' }}</span>
            </template>
            <template #cell(clientecnpj)="data">
              {{ data.item.clientecnpj || '-' }}
            </template>
            <template #cell(clienterazaosocial)="data">
              <span class="razao-cell">{{ data.item.clienterazaosocial || '-' }}</span>
            </template>
            <template #cell(clientestatus)="data">
              <span class="status-badge" :class="getStatusClass(data.item.clientestatus)">
                {{ data.item.clientestatus || '-' }}
              </span>
            </template>
            <template #cell(clientesitintegracao)="data">
              <span class="status-badge" :class="getIntegracaoClass(data.item.clienteiderp)">
                {{ data.item.clienteiderp ? 'Integrado' : 'Não Integrado' }}
              </span>
            </template>
            <template #cell(actions)="data">
              <div class="actions-cell">
                <button class="action-icon-btn" title="Visualizar" @click="openEditModal(data.item)">
                  <feather-icon icon="EyeIcon" size="14" />
                </button>
                <button
                  v-if="data.item.clienteiderp === null && data.item.clientestatus === 'DIGITACAO'"
                  class="action-icon-btn danger"
                  title="Excluir"
                  @click="openModalDeleteCustomField(data.item)"
                >
                  <feather-icon icon="TrashIcon" size="14" />
                </button>
              </div>
            </template>
            <template #empty>
              <div class="empty-state">
                <feather-icon icon="UsersIcon" size="32" class="empty-icon" />
                <p class="empty-text">Nenhum cliente encontrado</p>
                <p class="empty-subtext">Ajuste os filtros ou adicione um novo cliente</p>
              </div>
            </template>
          </b-table>
        </div>

        <div class="table-footer" v-if="totalCliente > 0">
          <div class="pagination-info">
            Página {{ currentPage }} de {{ Math.ceil(totalCliente / perPage) || 1 }}
          </div>
          <div class="pagination-controls">
            <button
              class="pagination-btn"
              :disabled="currentPage <= 1"
              @click="currentPage = 1"
            >
              <feather-icon icon="ChevronsLeftIcon" size="14" />
            </button>
            <button
              class="pagination-btn"
              :disabled="currentPage <= 1"
              @click="currentPage--"
            >
              <feather-icon icon="ChevronLeftIcon" size="14" />
            </button>
            <span class="page-indicator">{{ currentPage }}</span>
            <button
              class="pagination-btn"
              :disabled="currentPage >= Math.ceil(totalCliente / perPage)"
              @click="currentPage++"
            >
              <feather-icon icon="ChevronRightIcon" size="14" />
            </button>
            <button
              class="pagination-btn"
              :disabled="currentPage >= Math.ceil(totalCliente / perPage)"
              @click="currentPage = Math.ceil(totalCliente / perPage)"
            >
              <feather-icon icon="ChevronsRightIcon" size="14" />
            </button>
          </div>
        </div>
      </div>
    </b-overlay>

    <ModalAtt
      idModal="modal-att-cliente"
      titleModal="Visualizar Cliente"
      labelBtnOk="Fechar"
      v-model="dataCliente"
      @cancel="resetFormData()"
    />

    <ModalAdd
      idModal="modal-add-cliente"
      titleModal="Adicionar Cliente"
      labelBtnOk="Salvar"
      v-model="dataCliente"
      @ok="create($event)"
      @cancel="resetFormData()"
    />

    <modal-confirmation
      v-model="isDeleteModal"
      id-modal="modal-delete-cliente"
      title="Deletar Cliente"
      btn-cancel-label="Cancelar"
      btn-ok-label="Sim, deletar"
      @ok="handleRemover(deletedCustomField.clienteid)"
      @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar este cliente?</p>
        </div>
      </template>
    </modal-confirmation>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { BOverlay, BTable } from 'bootstrap-vue';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import ModalAtt from '@/views/cadastros/cliente/cliente/list/ModalAtt.vue';
import ModalAdd from '@/views/cadastros/cliente/cliente/add/ModalAdd.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ActionBar from '@/components/ActionBar.vue';
import useList from './useList';

export default {
  name: 'ClienteList',
  components: {
    BOverlay,
    BTable,
    ModalAtt,
    ModalAdd,
    ModalConfirmation,
    ActionBar,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedCustomField: {
        clienteid: null,
        clienteiderp: '',
      },
      searchInputValue: '',
      drawerOpen: false,
      filterSituacao: '',
      filterIntegracao: '',
      filterTipoPessoa: '',
      filterCnpj: '',
      appliedFilters: {
        situacao: '',
        integracao: '',
        tipoPessoa: '',
        cnpj: '',
      },
    };
  },
  computed: {
    activeFiltersCount() {
      let count = 0;
      if (this.appliedFilters.situacao) count++;
      if (this.appliedFilters.integracao) count++;
      if (this.appliedFilters.tipoPessoa) count++;
      if (this.appliedFilters.cnpj) count++;
      return count;
    },
    filterChipsData() {
      const chips = [];
      if (this.appliedFilters.situacao) {
        chips.push({ key: 'situacao', label: `Situação: ${this.appliedFilters.situacao}`, removable: true });
      }
      if (this.appliedFilters.integracao) {
        const label = this.appliedFilters.integracao === 'INTEGRADO' ? 'Integrado'
          : this.appliedFilters.integracao === 'NAO_INTEGRADO' ? 'Não Integrado' : 'Erro';
        chips.push({ key: 'integracao', label: `Integração: ${label}`, removable: true });
      }
      if (this.appliedFilters.tipoPessoa) {
        chips.push({ key: 'tipoPessoa', label: `Tipo: ${this.appliedFilters.tipoPessoa === 'J' ? 'Jurídica' : 'Física'}`, removable: true });
      }
      if (this.appliedFilters.cnpj) {
        chips.push({ key: 'cnpj', label: `CNPJ: ${this.appliedFilters.cnpj}`, removable: true });
      }
      return chips;
    },
    tableColumnsFormatted() {
      return [
        {
          key: 'clienteid', label: 'Código KS', sortable: false, thClass: 'th-cell', tdClass: 'td-cell',
        },
        {
          key: 'clienteiderp', label: 'Código ERP', sortable: true, thClass: 'th-cell', tdClass: 'td-cell',
        },
        {
          key: 'representanteid', label: 'Código Representante', sortable: true, thClass: 'th-cell', tdClass: 'td-cell',
        },
        {
          key: 'clientecnpj', label: 'CNPJ/CPF', sortable: true, thClass: 'th-cell', tdClass: 'td-cell',
        },
        {
          key: 'clienterazaosocial', label: 'Razão Social', sortable: true, thClass: 'th-cell', tdClass: 'td-cell',
        },
        {
          key: 'clientestatus', label: 'Situação', sortable: true, thClass: 'th-cell', tdClass: 'td-cell',
        },
        {
          key: 'clientesitintegracao', label: 'Integração', sortable: false, thClass: 'th-cell', tdClass: 'td-cell',
        },
        {
          key: 'actions', label: 'Ações', sortable: false, thClass: 'th-cell text-center', tdClass: 'td-cell',
        },
      ];
    },
  },
  methods: {
    applyGlobalSearchQuery() {
      const q = this.$route?.query?.q;
      if (!q) return;
      const value = Array.isArray(q) ? q[0] : q;
      this.searchInputValue = value;
      this.searchQuery = value;
    },
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Cliente deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataCliente = data;
      this.$bvModal.show('modal-att-cliente');
    },
    resetFormData() {
      this.deletedCustomField = {
        clienteid: null,
        clienteiderp: '',
      };
      this.dataCliente = {
        clienteid: null,
        clienteiderp: '',
      };
      this.isDeleteModal = false;
    },
    chamarRota() {
      this.$router.push({ name: 'apps-pre-cadastro-cliente' });
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
    openDrawer() {
      this.drawerOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeDrawer() {
      this.drawerOpen = false;
      document.body.style.overflow = '';
    },
    aplicarFiltros() {
      this.appliedFilters = {
        situacao: this.filterSituacao,
        integracao: this.filterIntegracao,
        tipoPessoa: this.filterTipoPessoa,
        cnpj: this.filterCnpj,
      };
      this.closeDrawer();
    },
    limparFiltrosDrawer() {
      this.filterSituacao = '';
      this.filterIntegracao = '';
      this.filterTipoPessoa = '';
      this.filterCnpj = '';
    },
    handleRemoveChip(chip) {
      if (chip.key === 'situacao') {
        this.appliedFilters.situacao = '';
        this.filterSituacao = '';
      }
      if (chip.key === 'integracao') {
        this.appliedFilters.integracao = '';
        this.filterIntegracao = '';
      }
      if (chip.key === 'tipoPessoa') {
        this.appliedFilters.tipoPessoa = '';
        this.filterTipoPessoa = '';
      }
      if (chip.key === 'cnpj') {
        this.appliedFilters.cnpj = '';
        this.filterCnpj = '';
      }
    },
    getStatusClass(status) {
      const map = {
        DIGITACAO: 'status-warning',
        FINALIZADO: 'status-success',
        CANCELADO: 'status-danger',
      };
      return map[status] || 'status-muted';
    },
    getIntegracaoClass(iderp) {
      return iderp ? 'status-success' : 'status-muted';
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.drawerOpen) {
        this.closeDrawer();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeydown);
    this.applyGlobalSearchQuery();
  },
  watch: {
    '$route.query.q': function () {
      this.applyGlobalSearchQuery();
    },
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = '';
  },
  setup() {
    const dataCliente = ref({
      clienteid: null,
      clienteiderp: '',
    });

    const {
      perPage,
      currentPage,
      totalCliente,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refClienteListTable,
      fetchCliente,
      overlay,
      create,
      Updated,
      removerData,
    } = useList();

    return {
      dataCliente,
      perPage,
      overlay,
      currentPage,
      totalCliente,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchCliente,
      tableColumns,
      refClienteListTable,
      Updated,
      create,
      removerData,
    };
  },
};
</script>

<style scoped>
.clientes-page {
  padding: 0.5rem 0.75rem;
  max-width: 100%;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
}

.breadcrumb-link {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: var(--text-muted, #64748b);
  text-decoration: none;
  transition: color 0.15s ease;
}

.breadcrumb-link:hover {
  color: #6366f1;
}

.breadcrumb-separator {
  color: var(--text-muted, #94a3b8);
}

.breadcrumb-current {
  color: var(--text-primary, #1e293b);
  font-weight: 500;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 280px;
}

.search-icon {
  position: absolute;
  left: 0.625rem;
  color: var(--text-muted, #94a3b8);
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 0.375rem 0.625rem 0.375rem 2rem;
  font-size: 0.8125rem;
  color: var(--text-primary, #1e293b);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  height: 32px;
  transition: all 0.15s ease;
}

.search-input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.search-input::placeholder {
  color: var(--text-muted, #94a3b8);
}

.action-bar-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.625rem;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  height: 32px;
}

.primary-btn {
  background: #6366f1;
  color: #ffffff;
  border: none;
}

.primary-btn:hover:not(:disabled) {
  background: #4f46e5;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.25);
}

.primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ghost-btn {
  background: var(--surface-bg, #f8fafc);
  color: var(--text-secondary, #64748b);
  border: 1px solid var(--border-color, #e5e7eb);
}

.ghost-btn:hover {
  background: var(--hover-bg, #f1f5f9);
  color: var(--text-primary, #1e293b);
}

.filter-drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1040;
}

.filter-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  max-width: 90vw;
  height: 100vh;
  background: var(--card-bg, #ffffff);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  z-index: 1050;
  display: flex;
  flex-direction: column;
}

.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.25s ease;
}

.drawer-slide-enter,
.drawer-slide-leave-to {
  transform: translateX(100%);
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  flex-shrink: 0;
}

.drawer-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary, #1e293b);
}

.drawer-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  transition: all 0.15s ease;
}

.drawer-close:hover {
  background: var(--hover-bg, #f1f5f9);
  color: var(--text-primary, #1e293b);
}

.drawer-body {
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
}

.field-group {
  margin-bottom: 1rem;
}

.field-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary, #64748b);
  margin-bottom: 0.375rem;
}

.field-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.8125rem;
  color: var(--text-primary, #1e293b);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  transition: all 0.15s ease;
}

.field-input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.drawer-footer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid var(--border-color, #e5e7eb);
  flex-shrink: 0;
}

.w-full {
  width: 100%;
  justify-content: center;
}

.content-card {
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  background: var(--surface-bg, #f8fafc);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.table-info {
  font-size: 0.75rem;
  color: var(--text-muted, #64748b);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.per-page-label {
  font-size: 0.75rem;
  color: var(--text-muted, #94a3b8);
  margin: 0;
}

.per-page-select {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  color: var(--text-primary, #1e293b);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 4px;
  cursor: pointer;
  height: 26px;
}

.table-container {
  overflow-x: auto;
}

.code-cell {
  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 0.75rem;
  color: var(--text-secondary, #64748b);
}

.razao-cell {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.125rem 0.5rem;
  font-size: 0.6875rem;
  font-weight: 500;
  border-radius: 100px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.status-success {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
}

.status-warning {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
}

.status-danger {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
}

.status-muted {
  background: var(--surface-bg, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}

.action-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: var(--surface-bg, #f1f5f9);
  color: #6366f1;
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.action-icon-btn:hover {
  background: #6366f1;
  color: #ffffff;
  border-color: #6366f1;
}

.action-icon-btn.danger {
  color: #dc2626;
}

.action-icon-btn.danger:hover {
  background: #dc2626;
  color: #ffffff;
  border-color: #dc2626;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.empty-icon {
  color: var(--text-muted, #94a3b8);
  margin-bottom: 0.75rem;
}

.empty-text {
  margin: 0 0 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary, #64748b);
}

.empty-subtext {
  margin: 0;
  font-size: 0.75rem;
  color: var(--text-muted, #94a3b8);
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  background: var(--surface-bg, #f8fafc);
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.pagination-info {
  font-size: 0.75rem;
  color: var(--text-muted, #64748b);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: var(--card-bg, #ffffff);
  color: var(--text-secondary, #64748b);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.pagination-btn:hover:not(:disabled) {
  background: var(--hover-bg, #f1f5f9);
  color: var(--text-primary, #1e293b);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #6366f1;
  background: rgba(99, 102, 241, 0.1);
  border-radius: 4px;
}

@media (max-width: 1024px) {
  .search-input-wrapper {
    min-width: 200px;
  }
}

@media (max-width: 768px) {
  .btn-text {
    display: none;
  }

  .search-input-wrapper {
    min-width: 150px;
  }
}

body.dark-layout .clientes-page {
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .breadcrumb-link {
  color: var(--dark-text-muted, #676d7d);
}

body.dark-layout .breadcrumb-current {
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .search-input {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .content-card {
  background: var(--dark-card-bg, #283046);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .card-header {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .filter-drawer {
  background: var(--dark-card-bg, #283046);
}

body.dark-layout .drawer-header,
body.dark-layout .drawer-footer {
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .drawer-title {
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .field-input {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .table-footer {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .pagination-btn {
  background: var(--dark-card-bg, #283046);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-secondary, #b4b7bd);
}

body.dark-layout .per-page-select {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .ghost-btn {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-secondary, #b4b7bd);
}

body.dark-layout .action-icon-btn {
  background: var(--dark-surface-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';

.data-table-btable {
  margin-bottom: 0;

  thead th {
    padding: 0.5rem 0.75rem !important;
    font-size: 0.6875rem !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.025em !important;
    color: var(--text-muted, #64748b) !important;
    background: var(--surface-bg, #f8fafc) !important;
    border-bottom: 1px solid var(--border-color, #e5e7eb) !important;
    border-top: none !important;
    white-space: nowrap !important;
  }

  tbody td {
    padding: 0.5rem 0.75rem !important;
    font-size: 0.8125rem !important;
    color: var(--text-primary, #1e293b) !important;
    border-bottom: 1px solid var(--border-color, #e5e7eb) !important;
    vertical-align: middle !important;
  }

  tbody tr:hover td {
    background: var(--hover-bg, #f8fafc) !important;
  }
}

body.dark-layout .data-table-btable {
  thead th {
    background: var(--dark-surface-bg, #242b3d) !important;
    color: var(--dark-text-muted, #676d7d) !important;
    border-color: var(--dark-border, #3b4253) !important;
  }

  tbody td {
    color: var(--dark-text-primary, #d0d2d6) !important;
    border-color: var(--dark-border, #3b4253) !important;
  }

  tbody tr:hover td {
    background: var(--dark-hover-bg, #2d3548) !important;
  }
}
</style>
